import type { components } from "admination-react/api-schema";
import { blobToBase64, captureWriteIdentity, sendJson } from "./http";

async function extractionSource(source: string | Blob): Promise<{ path: string } | components["schemas"]["UploadedExtractionIn"]> {
  if (typeof source === "string") return { path: source };
  const mime_type = source.type || "application/pdf";
  if (mime_type !== "application/pdf" && mime_type !== "image/jpeg" && mime_type !== "image/png" && mime_type !== "image/webp") throw new Error("Dateiformat nicht unterstützt.");
  const data = await blobToBase64(source);
  return { data, mime_type };
}

export type ExtractionSplitPlan = components["schemas"]["SplitPlanOut"];

export async function classifyPagesOnGate(path: string | Blob): Promise<ExtractionSplitPlan> {
  const identity = captureWriteIdentity();
  return sendJson<ExtractionSplitPlan>("/extraction/classify-pages", "POST", await extractionSource(path), undefined, identity);
}

export type ExtractionAvgsForm = Pick<components["schemas"]["AvgsFormOut"], "Teilnehmer" | "Kostenträger" | "Maßnahme">;

export async function extractAvgsOnGate(path: string | Blob): Promise<ExtractionAvgsForm> {
  const identity = captureWriteIdentity();
  return sendJson<ExtractionAvgsForm>("/extraction/extract-avgs", "POST", await extractionSource(path), undefined, identity);
}

export type ExtractionBewilligungForm = Pick<components["schemas"]["BewilligungFormOut"], "Teilnehmer" | "Kostenträger" | "Maßnahme">;

export async function extractBewilligungOnGate(path: string | Blob): Promise<ExtractionBewilligungForm> {
  const identity = captureWriteIdentity();
  return sendJson<ExtractionBewilligungForm>("/extraction/extract-bewilligung", "POST", await extractionSource(path), undefined, identity);
}

export type ExtractionTranscript = components["schemas"]["TranscribeOut"];

export type TranscribeContext = {

  feld?: string;

  kontext?: string;
};

export function transcribeOnGate(
  audioBase64: string,
  mimeType: string,
  opts: TranscribeContext = {},
): Promise<ExtractionTranscript> {
  const body: components["schemas"]["TranscribeIn"] = { audio_base64: audioBase64, mime_type: mimeType };
  if (opts.feld) body.feld = opts.feld;
  if (opts.kontext) body.kontext = opts.kontext;
  return sendJson<ExtractionTranscript>("/extraction/transcribe", "POST", body);
}
